var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3974_5389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3963 0H2.60367C1.1664 0.00166797 0.00166797 1.1664 0 2.60367V11.3963C0.00166797 12.8336 1.1664 13.9983 2.60367 14H11.3963C12.8336 13.9983 13.9983 12.8336 14 11.3963V2.60367C13.9983 1.1664 12.8336 0.00166797 11.3963 0ZM13.0335 2.60367V3.4478H10.5852L8.7541 0.966465H11.3964C12.3001 0.967477 13.0325 1.69988 13.0335 2.60367ZM7.55295 0.966465L9.38405 3.4478H6.44705L4.61595 0.966465H7.55295ZM0.966465 2.60367C0.967477 1.69991 1.69988 0.967504 2.60367 0.966465H3.41482L5.24593 3.4478H0.966465V2.60367ZM11.3963 13.0335H2.60367C1.69991 13.0325 0.967504 12.3001 0.966465 11.3963V4.41429H13.0335V11.3963C13.0325 12.3001 12.3001 13.0325 11.3963 13.0335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57917 8.30551L5.75611 6.09827C5.52497 5.96483 5.22944 6.04402 5.096 6.27515C5.05359 6.34863 5.03125 6.43194 5.03125 6.51679V10.9313C5.03125 11.1982 5.24759 11.4145 5.51447 11.4145C5.59929 11.4145 5.68263 11.3922 5.75611 11.3498L9.57917 9.14253C9.81031 9.00909 9.8895 8.71356 9.75606 8.48242C9.71362 8.40892 9.65262 8.34792 9.57917 8.30551ZM5.99771 10.0943V7.35376L8.3711 8.72401L5.99771 10.0943Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3974_5389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadData);
export default __webpack_public_path__ + "static/media/upload_data.5b30c393ad7301022ac803ff76df8987.svg";
export { ForwardRef as ReactComponent };